import React, { useState } from 'react';
import styles from 'routes/vendorRe/pages/common/VendorMenuBar.module.css';
import Container from 'routes/vendorRe/containers/commons/Container';
import HorizontalFlex from 'routes/vendorRe/containers/commons/HorizontalFlex';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import hamBtn from 'routes/vendorRe/images/ham_btn.png';
import configIcon from 'routes/vendorRe/images/config_icon.png';
import alertIcon from 'routes/vendorRe/images/alert_icon.png';
import backIcon from 'routes/vendorRe/images/back_icon.png';
import VendorModal from './VendorModal';
import useCustomMove from 'routes/vendorRe/hooks/useCustomMove';
import { 
    commonBgColor, 
    
} from 'routes/vendorRe/constraint/constraints';
import home1 from 'routes/vendorRe/images/homeIcon.png';
import home2 from 'routes/vendorRe/images/homeIcon2.png';

const VendorMenuBar = () => {
    const [show, setShow] = useState(false);
    const {moveToBack, moveToHome} = useCustomMove();
    
    const handleClickModal = (e) => {
        setShow(true);
    };
    const closeModal = () => {
        setShow(false);
    };

    return (
        <div className={styles.fixed}>
            <Container height="10vh" backgroundColor={commonBgColor}>
                {/* 모달 처리 */}
                {show && (
                    <VendorModal 
                    callbackFn={closeModal}
                    /> 
                )}
                <HorizontalFlex padding="0 40px">
                    <FlexChild>
                        <img onClick={() => [moveToBack()]} className={styles.backIcon} src={backIcon} alt='메인으로 돌아가기 아이콘' />
                    </FlexChild>
                    <FlexChild gap="1.5em" justifyContent="flex-end">
                        <img className={styles.menuIcon} src={configIcon} alt='설정 아이콘' />
                        <img className={styles.menuIcon} src={alertIcon} alt='알림 아이콘' />
                        <img onClick={() => moveToHome()} className={styles.menuIcon} src={home1} alt='홈 아이콘' />
                        <img onClick={() => handleClickModal()} className={styles.menuIcon} src={hamBtn} alt='모바일 내비게이션 버튼' />
                    </FlexChild>
                </HorizontalFlex>
            </Container>
        </div>
    );
};

export default VendorMenuBar;